import vuexStoreFactory from "@/_util/vuex-store-factory"
let factory = new vuexStoreFactory();
import config from "@/_store/modules/user-settings-config"
import appData from "@/_data/application-data"
import appSettings from "@/_mixins/app-settings-mixin"
import globalAppConfig from "@/app.config.global.js"

export default {
  mixins : [factory.generateMixin(config),appSettings],
  mounted(){
    this.applyThemeSettings(this.themeSettings);
  },
  data() {
      return {
      }
  },
  watch : {
    themeSettings(newVal)
    {
      //reset all of the persistent color settings
      // debugger;      
      this.applyThemeSettings(newVal);
      //backgroundImage
    }
  },
  computed : {
    themes()
    {
      return globalAppConfig.themes;
    },

    currentTheme : {
      get() {
        return this.globalCurrentTheme || globalAppConfig.defaultTheme;
      },
      set(val) {
        this.globalCurrentTheme = val;
      }
    },

    themeSettings()
    {
      var theme = !!this.currentTheme
        ? globalAppConfig.themes.filter(e => e.id == this.currentTheme)
        : globalAppConfig.themes.filter(e => e.id == globalAppConfig.defaultTheme);

      if(theme.length > 0)
      {
        return theme[0];
      }
      return globalAppConfig.themes[0];
    },

    darkMode : {
      get() {
        return this.globalDarkMode != null
        ? this.globalDarkMode
        : this.themeSettings.dark;
      },
      set(val) {
        this.globalDarkMode = val;
      }
    },
      
    topBarColorString()
    {
      return !!this.globalTopBarColor
        ? this.rgbaToString(this.globalTopBarColor) 
        : "rgba(0,0,0,0)";
    },
    appData()
    {
        return appData;
    },
    
    pinnedAppInfo()
    {
        return this.globalPinnedApps.map(e => {
            var arr = this.appData.filter(d => d.id == e);
            return arr.length > 0 ? arr[0] : null;
        })
    },
  },
  methods : {
    applyThemeSettings(newVal)
    {
      this.globalDarkMode = newVal.dark
      this.globalNavBackgroundColor = newVal.navBackgroundColor;
      this.globalContentBackgroundColor = newVal.contentBackgroundColor
      this.globalAppBackgroundColor = newVal.appBackgroundColor;
      this.globalTopBarColor = newVal.topBarColor;
      this.globalBackgroundImage = newVal.backgroundImage;

      this.$vuetify.theme.dark = newVal.dark;
    },
    rgbaToString(rgba)
    {
        var ret = `rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`;
        return ret;
    },
    removePinnedApp(id)
    {
        var index = this.globalPinnedApps.indexOf(id);
        this.globalPinnedApps.splice(index,1);
        // this.globalLoadedAnimations.splice(this.globalLoadedAnimations.indexOf(id),1);
    },
    addPinnedApp(id)
    {
        //ensure that the animation queue doesnt have any items.
        // var lanimIndex = this.globalLoadedAnimations.indexOf(id);
        // lanimIndex > 0 ? this.globalLoadedAnimations.splice(lanimIndex,1) : false;

        var index = this.globalPinnedApps.indexOf(id);
        if(index < 0)
        {
            this.globalPinnedApps = this.globalPinnedApps.concat([id]);
        }
    }
  }
}